import { StringBoolean } from '../types/global';

export const stringToBool = (val: StringBoolean) =>
  val === 'true' ? true : false;
